import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { ResyncService } from '../../services/resync.service';
import { BackgroundTask } from '../../models/background-task';
import { BackgroundTaskService } from '../../services/background-task.service';
import { CatchUpDialogComponent, CatchUpDialogResult } from '../catch-up-dialog/catch-up-dialog.component';

@Component({
    selector: 'app-management',
    templateUrl: './management.component.html',
    styleUrls: ['./management.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManagementComponent implements OnInit {

  tasks: BackgroundTask[];
  catchUpInProgress = false;

  constructor(
    private resyncService: ResyncService,
    private backgroundTaskService: BackgroundTaskService,
    private dialog: MatDialog,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this.loadTaskList();
  }

  resyncPim() {
    this.resyncService.resyncPim().subscribe(() => this.loadTaskList());
  }

  resyncIdentity() {
    this.resyncService.resyncIdentity().subscribe(() => this.loadTaskList());
  }

  onCatchUp(): void {
    const dialogRef = this.dialog.open(CatchUpDialogComponent, {
      autoFocus: false,
      restoreFocus: false,
      width: '420px'
    });
    dialogRef.afterClosed().subscribe((result: CatchUpDialogResult | undefined) => {
      if (!result) { return; }
      this.catchUpInProgress = true;
      this.resyncService.catchUp(result.deleteAfterIngest).subscribe({
        next: () => {
          this.catchUpInProgress = false;
          this.loadTaskList();
          this.snackbarService.success('MANAGEMENT.CATCH_UP_SUCCESS');
        },
        error: () => {
          this.catchUpInProgress = false;
          this.snackbarService.error('MANAGEMENT.CATCH_UP_ERROR');
        }
      });
    });
  }

  loadTaskList() {
    this.backgroundTaskService.getTasks().subscribe(tasks => this.tasks = tasks);
  }
}
